import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure20 = {
chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    height: '450px',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#ed7d31', '#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },

  xAxis: [{
    categories: [ "Asie de l’Est et Asie du Sud-Est", "Asie de l’Ouest et Afrique du Nord", "Océanie (hors Australie et Nouvelle-Zélande)", "Amérique du Nord et Europe", "Amérique latine et Caraïbes", "Afrique subsaharienne", "Asie centrale et Asie du Sud", "Australie et Nouvelle-Zélande" ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{
    labels: {
      	format: '{value}',
      formatter: function () {
        return (this.value / 1000000) + "M";
    },
    style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    max: 3000000,
    min: 0,
    tickInterval: 500000,
    gridLineWidth: 2,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: '2021',
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }
    },
    data: [ 344843, 241778, 4738, 2796969, 465618, 213494, 592772, 285200 ],
  },
  {
    name: '2000',
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }
    },
    data:[ 214285, 65576, 1347, 1637687, 265441, 143323, 351299, 196154 ]
  }
]
}